import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const features = [{
  emoji: '👩‍🍳',
  text: 'Recetas paso a paso fáciles de seguir, incluso si no sabes cocinar.'
}, {
  emoji: '🛒',
  text: 'Listas de compras semanales para ahorrar tiempo y dinero en el súper.'
}, {
  emoji: '📅',
  text: 'Plan de comidas de 30 días diseñado para desinflamar tu hígado.'
}, {
  emoji: '🥬',
  text: 'Ingredientes accesibles y económicos que encuentras en cualquier mercado.'
}, {
  emoji: '⚖️',
  text: 'Porciones exactas y valores nutricionales para evitar excesos.'
}, {
  emoji: '✨',
  text: 'Cero ingredientes raros, costosos o difíciles de conseguir.'
}];
export function Solution() {
  return <section className="py-20 bg-white" data-id="element-179">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-181">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:w-1/2" data-id="element-182">
            <div className="bg-brand-primary/5 p-8 rounded-3xl" data-id="element-183">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-184">
                La solución definitiva para transformar tu salud hepática
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-185">
                Hemos creado el programa más completo y fácil de seguir.
                Olvídate de las dietas restrictivas y aburridas. Con nuestro
                recetario, apoyar el bienestar de tu hígado será un proceso
                delicioso y natural.
              </p>

              <ul className="space-y-4" data-id="element-186">
                {features.map((feature, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="flex items-start gap-3" data-id="element-187">
                    <span className="text-2xl flex-shrink-0 leading-none mt-0.5" role="img" aria-hidden="true" data-id="element-188">
                      {feature.emoji}
                    </span>
                    <span className="text-gray-700 font-medium" data-id="element-189">
                      {feature.text}
                    </span>
                  </motion.li>)}
              </ul>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:w-1/2" data-id="element-190">
            <div className="rounded-3xl overflow-hidden shadow-2xl ring-1 ring-brand-primary/10" data-id="element-191">
              <img src="https://cdn.magicpatterns.com/uploads/bEULSCjFMGafYDexigYMSS/Copilot_20260616_193057.png" alt="Mockup del recetario digital 'Recetas Deliciosas para Hígados Sanos' mostrado en tablet, celular y guía impresa junto a ingredientes saludables." className="w-full h-auto object-cover" loading="lazy" data-id="element-192" />
            </div>
            <p className="text-center text-brand-primary font-semibold mt-4" data-id="element-193">
              Formato 100% Digital (PDF) · Acceso desde cualquier dispositivo
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}